import { ButtonWidget } from 'angular2-schema-form';
import { Component } from '@angular/core';

@Component({
  selector: 'app-sf-button-widget',
  templateUrl: './button.widget.html'
})
export class MyButtonWidgetComponent extends ButtonWidget {
  buttonFunction(param) {
    console.log('param', param);
  }
}



// WEBPACK FOOTER //
// ./src/shared/form-widgets/button/button.widget.ts